import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';

import spacing from '@decisiv/design-tokens/lib/spacing';

import { Flex } from '@decisiv/ui-components';

export const Container = styled(Flex)`
  gap: ${rem(spacing.base * 0.5)};

  max-width: ${rem(spacing.base * 20)};
  flex-wrap: wrap;
`;
